module.exports = __webpack_public_path__ + "img/1.d7ed8dd0.jpg";